import Icon, { IconProps } from './Icon';

import DownloadFile from '../../../assets/icons/downlaod-file.svg?react';

const Download: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <DownloadFile />
        </Icon>
    );
};

export default Download;
